export default {
  title: 'Prezentare generală companie',
  description: 'Bun revenit, {{name}}! Iată ce se întâmplă cu marketingul dvs.',
};
